import { useSyncExternalStore } from "react";
import { Platform } from "react-native";
// Both apps use this chat for support (Intercom was removed in iOS 4.3.0) unless a build sets
// EXPO_PUBLIC_SUPPORT_ENABLED to "false"; web reads the flag from the Netlify build env.
export const supportEnabled =
  Platform.OS === "web"
    ? process.env.EXPO_PUBLIC_SUPPORT_ENABLED === "true"
    : process.env.EXPO_PUBLIC_SUPPORT_ENABLED !== "false";
export const supportApi = (
  process.env.EXPO_PUBLIC_SUPPORT_API_URL || "https://evt.live/api/support/chat"
).replace(/\/$/, "");
// Chat for visitors who aren't signed in: web only (the backend checks the page's origin).
export const supportPublic =
  supportEnabled &&
  Platform.OS === "web" &&
  process.env.EXPO_PUBLIC_SUPPORT_PUBLIC === "true";
// Sites allowed to embed /support-embed (the website chat on eventlive.pro and evt.live).
export const supportEmbedParents = (
  process.env.EXPO_PUBLIC_SUPPORT_EMBED_PARENTS ||
  "https://www.eventlive.pro,https://eventlive.pro,https://evt.live"
)
  .split(",")
  .map((s) => s.trim())
  .filter(Boolean);
export const signInUrl = "https://broadcaster.eventlive.pro/signin";
const listeners = new Set();
export function openSupport() {
  listeners.forEach((fn) => fn());
  return true;
}
export function onOpenSupport(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
// What the header support buttons show: whether the chat can open (signed in and
// loaded) and whether a reply arrived while it was closed. Set by SupportWidget.
let status = { available: false, unread: false };
const statusListeners = new Set();
export function setSupportStatus(next) {
  const merged = { ...status, ...next };
  if (merged.available === status.available && merged.unread === status.unread)
    return;
  status = merged;
  statusListeners.forEach((fn) => fn());
}
export function useSupportStatus() {
  return useSyncExternalStore(
    (fn) => {
      statusListeners.add(fn);
      return () => statusListeners.delete(fn);
    },
    () => status
  );
}
// The screen on top, set by AppRouting. The floating Help launcher stays off
// onboarding and its sign-up page, which keep every step to a single choice.
export const ONBOARDING_ROUTES = new Set(["OnboardingNew", "SignUpSignIn"]);
let route = null;
const routeListeners = new Set();
export function setSupportRoute(name) {
  if (name === route) return;
  route = name;
  routeListeners.forEach((fn) => fn());
}
export function useSupportRoute() {
  return useSyncExternalStore(
    (fn) => {
      routeListeners.add(fn);
      return () => routeListeners.delete(fn);
    },
    () => route
  );
}
